import { gql } from '@apollo/client';

export const ADMIN_SEARCH_PROPERTIES = gql`
  query ADMIN_SEARCH_PROPERTIES($propertyName: String!) {
    AdminQueries {
      propertyTypeahead(propertyName: $propertyName) {
        id
        name
      }
    }
  }
`;

export const ADMIN_SEARCH_SUPPLIERS = gql`
  query ADMIN_SEARCH_SUPPLIERS($supplierName: String!) {
    AdminQueries {
      supplierTypeahead(supplierName: $supplierName) {
        id
        name
      }
    }
  }
`;

export const ADMIN_SEARCH_BOOKINGS = gql`
  query ADMIN_SEARCH_BOOKINGS($bookingNumber: String!, $draftBooking: Boolean) {
    AdminQueries {
      bookingTypeahead(bookingNumber: $bookingNumber, draftBooking: $draftBooking) {
        id
        bookingNumber
        confirmationNumber
      }
    }
  }
`;

export const ADMIN_SEARCH_TRACKINGCODE = gql`
  query ADMIN_SEARCH_TRACKINGCODE($search: CostTrackingTypeaheadInput) {
    AdminQueries {
      costTrackingCodeTypeahead(search: $search) {
        code
        id
      }
    }
  }
`;

export const ADMIN_SEARCH_CUSTOMERS = gql`
  query ADMIN_SEARCH_CUSTOMERS($customerName: String!) {
    AdminQueries {
      customerTypeahead(customerName: $customerName) {
        id
        name
      }
    }
  }
`;

export const ADMIN_SEARCH_ORGANIZATIONS = gql`
  query ADMIN_SEARCH_ORGANIZATIONS($organizationName: String!) {
    AdminQueries {
      customerTypeahead(customerName: $organizationName) {
        id
        name
      }
    }
  }
`;

export const ADMIN_SEARCH_BOOKING_GUEST = gql`
  query ADMIN_SEARCH_BOOKING_GUEST($guestName: String!, $orgId: Int, $bookingId: Int) {
    AdminQueries {
      bookingGuestTypeahead(search: { guestName: $guestName, orgId: $orgId, bookingId: $bookingId }) {
        id
        firstName
        lastName
        booking {
          id
          organization {
            id
            name
          }
        }
      }
    }
  }
`;

export const ADMIN_SEARCH_BOOKING_GUEST_EMAIL = gql`
  query ADMIN_SEARCH_BOOKING_GUEST($bookingOwnerEmail: String!) {
    AdminQueries {
      bookingOwnerEmailTypeahead(bookingOwnerEmail: $bookingOwnerEmail) {
        id
        owner {
          id
          emailAddress
        }
      }
    }
  }
`;

export const ADMIN_SEARCH_PAYMENT_CODE = gql`
  query ADMIN_SEARCH_PAYMENT_CODE($paymentCode: String!) {
    AdminQueries {
      paymentCodeTypeahead(paymentCode: $paymentCode) {
        id
        code
      }
    }
  }
`;

export const ADMIN_SEARCH_TICKETS_HELPDESK_ID = gql`
  query ADMIN_SEARCH_TICKETS_HELPDESK_ID($helpDeskId: String!) {
    AdminQueries {
      ticketTypeahead(helpDeskId: $helpDeskId) {
        id
        helpDeskId
      }
    }
  }
`;

export const ADMIN_SEARCH_FILENAME = gql`
  query ADMIN_SEARCH_FILENAME($fileName: String!) {
    AdminQueries {
      fileNameTypeahead(fileName: $fileName) {
        id
        fileName
      }
    }
  }
`;

export const ADMIN_SEARCH_FOLIO = gql`
  query ADMIN_SEARCH_FOLIO($folioId: String!) {
    AdminQueries {
      folioIdTypeahead(folioId: $folioId) {
        id
      }
    }
  }
`;

export const ADMIN_SEARCH_FOLIO_SOURCE_EMAIL = gql`
  query ADMIN_SEARCH_FOLIO_SOURCE_EMAIL($sourceEmail: String!) {
    AdminQueries {
      folioSourceEmailTypeahead(sourceEmail: $sourceEmail) {
        id
        sourceEmail
        createdBy {
          id
          emailAddress
        }
      }
    }
  }
`;

export const ADMIN_SEARCH_CHARGESHEET_GUEST_NAME = gql`
  query ADMIN_SEARCH_CHARGESHEET_GUEST_NAME($guestName: String!) {
    AdminQueries {
      chargesheetGuestNameTypeahead(guestName: $guestName) {
        id
        firstName
        lastName
      }
    }
  }
`;

export const QUERY_SEARCH_ROOM_TYPES = gql`
  query QUERY_SEARCH_ROOM_TYPES($roomName: String!, $propertyId: Int!) {
    AdminQueries {
      roomTypeahead(roomName: $roomName, propertyId: $propertyId) {
        id
        name
      }
    }
  }
`;

export const SUPPLIER_SEARCH_LOCATIONS = gql`
  query SUPPLIER_SEARCH_LOCATIONS($locationName: String!) {
    SupplierQueries {
      locationTypeahead(locationName: $locationName) {
        id
        name
        region
        country
        regionAbbreviation
        countryAbbreviation
        geo {
          lat
          lng
        }
      }
    }
  }
`;

export const SUPPLIER_SEARCH_REGIONS = gql`
  query SUPPLIER_SEARCH_REGIONS($regionName: String!) {
    SupplierQueries {
      regionTypeahead(regionName: $regionName) {
        id
        name
        country
        regionAbbreviation
        countryAbbreviation
      }
    }
  }
`;

export const SUPPLIER_SEARCH_COUNTRIES = gql`
  query SUPPLIER_SEARCH_COUNTRIES($countryName: String!) {
    SupplierQueries {
      countryTypeahead(countryName: $countryName) {
        id
        name
        abbreviation
      }
    }
  }
`;

export const SUPPLIER_SEARCH_COUNTIES = gql`
  query SUPPLIER_SEARCH_COUNTIES($countyName: String!) {
    SupplierQueries {
      countyTypeahead(countyName: $countyName) {
        id
        name
        region
        country
      }
    }
  }
`;

export const ADMIN_SEARCH_CONNECTION_TYPES = gql`
  query ADMIN_SEARCH_CONNECTION_TYPES($connectionTypeName: String!) {
    AdminQueries {
      connectorConnectionTypeTypeahead(connectionTypeName: $connectionTypeName) {
        id
        connectionType
      }
    }
  }
`;

export const SUPPLIER_CHAIN_CODE = gql`
  query SUPPLIER_CHAIN_CODE($chainName: String!) {
    SupplierQueries {
      chainCodeTypeahead(chainName: $chainName) {
        sabreChainCode
        sabreChainName
      }
    }
  }
`;

export const INVOICE_NUMBER = gql`
  query INVOICE_NUMBER($invoiceNumber: String) {
    AdminQueries {
      invoiceNumberTypeahead(invoiceNumber: $invoiceNumber) {
        id
        invoiceNumber
      }
    }
  }
`;

export const ADMIN_SEARCH_TAX_FEES = gql`
  query ADMIN_SEARCH_TAX_FEES($taxFeeName: String!) {
    AdminQueries {
      queryTaxFeeTypeahead(taxFeeName: $taxFeeName) {
        id
        name
      }
    }
  }
`;

export const ADMIN_SEARCH_IDENTITIES = gql`
  query AdminQueriesIdentityTypeahead($emailAddress: String!) {
    AdminQueries {
      identityTypeahead(emailAddress: $emailAddress) {
        __typename
        id
        emailAddress
        user {
          __typename
          id
          currentOrganization {
            __typename
            id
            name
          }
        }
      }
    }
  }
`;

export const ADMIN_SEARCH_MCC_SUPPORTED_BOOKINGS = gql`
  query ADMIN_SEARCH_MCC_SUPPORTED_BOOKINGS($bookingNumber: String!) {
    AdminQueries {
      bookingTypeaheadMCCSupported(bookingNumber: $bookingNumber) {
        id
        bookingNumber
        confirmationNumber
      }
    }
  }
`;

export const ADMIN_SEARCH_LOCALES = gql`
  query getLocales {
    getLocales {
      id
      currencyName
    }
  }
`;

export const QUERY_ALL_PROPERTIES = gql`
  query AdminQueries {
    AdminQueries {
      queryAllProperties {
        totalCount
        propertiesCount
        properties {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_ALL_PROPERTIES_FOR_BULK_CS_CREATE = gql`
  query AdminQueries {
    AdminQueries {
      queryAllPropertiesForChargesheetsCreate {
        totalCount
        propertiesCount
        properties {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_ALL_PAYMENT_CODES_FOR_BULK_CS_CREATE = gql`
  query AdminQueries {
    AdminQueries {
      getPaymentCodes {
        id
        code
        active
        expiryDate
      }
    }
  }
`;
